import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=0989c2eb&scoped=true&lang=css"
import "./Customer.vue?vue&type=style&index=1&id=0989c2eb&scoped=true&lang=css"
import "./Customer.vue?vue&type=style&index=2&id=0989c2eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0989c2eb"]])

export default __exports__